import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { CertificateNavigationItem } from '@app/layout/sidebar/models/certificate-navigation-item.model'
import { certificateStatusColor } from '../certificate-status'
import { certificateListName } from '../certificate-name'

@Component({
  selector: 'albert-list-view-insured-certificate-item',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './list-view-insured-certificate-item.component.html',
  styleUrl: './list-view-insured-certificate-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewInsuredCertificateItemComponent {
  public readonly item = input.required<CertificateNavigationItem>()
  public readonly selected = input<boolean>(false)
  /** Disables the options button while it stays visible, e.g. while several certificates are selected. */
  public readonly optionsDisabled = input<boolean>(false)
  /** Bulk actions only make sense for several certificates, so right-click is off until then. */
  public readonly bulkOptionsEnabled = input<boolean>(false)
  public readonly itemClicked = output()
  public readonly toggled = output<string>()
  public readonly optionsRequested = output<CertificateNavigationItem>()
  public readonly bulkOptionsRequested = output()
  public readonly statusColor = computed(() => certificateStatusColor(this.item().certificateStatus))
  public readonly name = computed(() => certificateListName(this.item()))

  public onEntryClick(event: MouseEvent): void {
    if (event.shiftKey) {
      event.preventDefault()
      this.toggled.emit(this.item().uuid)
      return
    }
    this.itemClicked.emit()
  }

  public onOptionsClick(): void {
    if (this.optionsDisabled()) {
      return
    }
    this.optionsRequested.emit(this.item())
  }

  public onContextMenu(event: MouseEvent): void {
    if (!this.selected() || !this.bulkOptionsEnabled()) {
      return
    }
    event.preventDefault()
    this.bulkOptionsRequested.emit()
  }
}
